import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useTranslator } from '@/hooks/useTranslator';

interface IntercomConsentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAccept: () => void;
}

export function IntercomConsentDialog({
  open,
  onOpenChange,
  onAccept,
}: IntercomConsentDialogProps) {
  const { getTranslation: t } = useTranslator({ page: 'appHeader' });

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader className='flex flex-col gap-3'>
          <div className='flex items-center gap-2.5'>
            <span className='flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 shrink-0'>
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className='text-primary text-sm'
              />
            </span>
            <AlertDialogTitle>{t('intercomConsent.title')}</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            {t('intercomConsent.description')}{' '}
            <a
              href='https://www.retraced.com/pages/privacy-policy'
              target='_blank'
              rel='noreferrer'
              className='text-primary underline'
            >
              {t('intercomConsent.privacyPolicy')}
            </a>
            .
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('intercomConsent.decline')}</AlertDialogCancel>
          <AlertDialogAction variant='default' onClick={onAccept}>
            {t('intercomConsent.accept')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
